/*
* <license header>
*/

export const extensionId = 'sample-extension';
